var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"text","disabled":!_vm.allowBlock},on:{"click":function($event){return _vm.addBlock()}}},[_c('i',{staticClass:"el-icon-circle-close"}),_vm._v(" 拉黑 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }